import { QueryResult } from '@apollo/client'
import { GetDsActionsQuery, useGetDsActionsQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

type GetDsActionsQueryResult = QueryResult<GetDsActionsQuery>
export type DSAction = GetDsActionsQuery['dsActions']['records'][0]

const { Provider, useContextFn } = createStrictContext<{
  records: DSAction[]
  refetch: GetDsActionsQueryResult['refetch']
  fetching: GetDsActionsQueryResult['loading']
}>('ActionsTableContext')

export const useActionsTableContext = useContextFn

export const ActionsTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    refetch,
    loading: fetching,
  } = useGetDsActionsQuery({
    ...DefaultQueryHookOptions,
    variables: {
      dsActionListInput: {
        projectId: { equals: projectId },
      },
    },
  })
  return (
    <Provider
      value={{
        records: data?.dsActions?.records ?? [],
        refetch,
        fetching,
      }}
    >
      {children}
    </Provider>
  )
}
